// Accordion toggle for the single-recipe ingredients/instructions panels.
document.querySelectorAll('.accordion').forEach((accordion) => {
  accordion.addEventListener('click', function () {
    this.classList.toggle('expanded');
    const panel = this.nextElementSibling;
    if (!panel) return;
    panel.style.display = panel.style.display === 'block' ? 'none' : 'block';
  });

  // Panels flagged expanded start open.
  if (accordion.classList.contains('expanded') && accordion.nextElementSibling) {
    accordion.nextElementSibling.style.display = 'block';
  }
});
